export default {
    bathroom: 'Salle de bain',
    furniture: 'Meuble',
    kitchen: 'Cuisine',
    qrcodeSummary: "Scannez le QR code avec votre smartphone pour voir le produit en réalité augmentée",
    seeinar: 'Voir en RA',
    storage: 'Placard',
}